module.exports = __webpack_public_path__ + "img/blazer-22.2e6f3a87.png";